import React from "react";
import ReactPaginate from "react-paginate";

export default function Pagination({
  pageCount,
  pageValue,
  setPage,
  total,
  pageSize = 10,
  itemLabel = "entries",
  showInfo = true,
  onPageChange,
  currentPage,
  totalPages,
}) {
  const resolvedPage = pageValue ?? currentPage ?? 0;
  const resolvedPageCount = pageCount ?? totalPages ?? 0;
  const handleChange =
    setPage ??
    onPageChange ??
    (() => {});

  const from = total > 0 ? resolvedPage * pageSize + 1 : 0;
  const to =
    total > 0
      ? Math.min((resolvedPage + 1) * pageSize, total)
      : 0;

  if ((!resolvedPageCount || resolvedPageCount <= 1) && (!showInfo || total == null || total === 0)) {
    return null;
  }

  return (
    <div className="qx-pagination">
      {showInfo && total != null && total > 0 && (
        <p className="qx-pagination-info">
          {from} to {to} of {total} {itemLabel}
        </p>
      )}

      {resolvedPageCount > 1 && (
        <ReactPaginate
          pageCount={resolvedPageCount}
          forcePage={resolvedPage}
          previousLabel="‹"
          nextLabel="›"
          breakLabel="…"
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          containerClassName="qx-pagination-list"
          pageClassName="qx-pagination-item"
          pageLinkClassName="qx-pagination-link"
          previousClassName="qx-pagination-item qx-pagination-item--nav"
          previousLinkClassName="qx-pagination-link"
          nextClassName="qx-pagination-item qx-pagination-item--nav"
          nextLinkClassName="qx-pagination-link"
          breakClassName="qx-pagination-item qx-pagination-item--break"
          breakLinkClassName="qx-pagination-link"
          activeClassName="qx-pagination-item--active"
          disabledClassName="qx-pagination-item--disabled"
          onPageChange={(selected) => {
            handleChange(selected.selected);
          }}
        />
      )}
    </div>
  );
}
